import { render, staticRenderFns } from "./setNav.vue?vue&type=template&id=20eb45bf&scoped=true&"
import script from "./setNav.vue?vue&type=script&lang=js&"
export * from "./setNav.vue?vue&type=script&lang=js&"
import style0 from "./setNav.vue?vue&type=style&index=0&id=20eb45bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb45bf",
  null
  
)

export default component.exports